import { GroupBase } from 'react-select';
import ReactAsyncCreatableSelect, { AsyncCreatableProps } from 'react-select/async-creatable';
import { ISelectOption, ISelectCustomProps } from '../interfaces';
import SelectLayout from '../SelectLayout';

const AsyncCreatableSelect = <
  SOption extends ISelectOption = ISelectOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<SOption> = GroupBase<SOption>,
>(selectProps: ISelectCustomProps<SOption, IsMulti, Group> & AsyncCreatableProps<SOption, IsMulti, Group>) => (
  <SelectLayout { ...selectProps } component={ ReactAsyncCreatableSelect } />
);

export default AsyncCreatableSelect;
